import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import PageRoute from '../../components/Routes/PageRoute';
import { mappingsAnalytics } from './types/mappingsAnalytics';
import { UserCapabilityName } from '../../types/userCapabilityName';

const { mappingsTable, createMappings, editMappings } = mappingsAnalytics;

const Mappings = lazy(
  () => import(/* webpackChunkName: "mappings" */ './Mappings')
);

const CreateMappingForm = lazy(
  () =>
    import(/* webpackChunkName: "create-mapping-form" */ './CreateMappingForm')
);

const EditMappingForm = lazy(
  () => import(/* webpackChunkName: "edit-mapping-form" */ './EditMappingForm')
);

export const mappingsRoutes = (
  <Route path="mappings/*">
    <Route
      path=""
      element={
        <PageRoute
          pageInfo={mappingsTable}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.ViewInternalAccessPolicies,
          ]}
        >
          <Mappings />
        </PageRoute>
      }
    />
    <Route
      path="create"
      element={
        <PageRoute
          pageInfo={createMappings}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.CreateAccessPolicy,
            UserCapabilityName.CreateInternalAccessPolicy,
          ]}
        >
          <CreateMappingForm />
        </PageRoute>
      }
    />
    <Route
      path="edit"
      element={
        <PageRoute
          pageInfo={editMappings}
          userCapabilities={[
            UserCapabilityName.SuperAdmin,
            UserCapabilityName.EditAccessPolicy,
            UserCapabilityName.EditInternalAccessPolicy,
          ]}
        >
          <EditMappingForm />
        </PageRoute>
      }
    />
  </Route>
);
